// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"1e968474","118":"91acacfd"}[chunkId] + ".chunk.js";
};